<template src="./template.html"></template>

<script>
  import { mapState } from 'vuex'
  import MetaHeader from '@/components/layout/MetaHeader'

  export default {
    name: 'NewsLetterSubscriptionOverlay',
    components: {
      MetaHeader,
    },
    props: {
      cancelationType: String,
      successfullyUnsubscribed: Boolean,
    },
    data() {
      return {
        isOpen: true,
      }
    },
    computed: {
      ...mapState('auth', { isAuthenticated: 'status' }),
      opened: {
        set() {
          this.isOpen = false
        },
        get() {
          return this.isOpen
        },
      },
      newsletterUnsubscribeMessage() {
        const isNotification = Boolean(this.$route.query.notification)

        return this.successfullyUnsubscribed ? this.$t(`${ isNotification ? 'notifications' : 'news_letter'}.unsubscribe.successful.message`) : this.$t(`${ isNotification ? 'notifications' : 'news_letter'}.unsubscribe.unsuccessful.message`)
      },
      newsletterUnsubscribeTitle() {
        const isNotification = Boolean(this.$route.query.notification)

        return this.successfullyUnsubscribed ? this.$t(`${ isNotification ? 'notifications' : 'news_letter'}.unsubscribe.successful.title`) : this.$t(`${ isNotification ? 'notifications' : 'news_letter'}.unsubscribe.unsuccessful.title`)
      },
      getClass() {
        return !this.isAuthenticated ? 'inauthenticated-custom-overlay' : ''
      },
    },
    methods: {
      closeNewsletterOverlay() {
        this.opened = false
        this.$emit('closeNewsletterOverlay')
      },
    },
  }
</script>
